import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as action from '../actions/entities';
import { RootState } from '../reducers';
import { Entities } from '../../components/Entities/types';
import { useRouter } from 'helpers/customHooks';
import { FILTER_KEYS, LEAGUES, SCOPE } from 'config/constants';
import { useFiltersState } from './filters';

export const useEntitiesState = () => {
  const {scope, specificScope} = useRouter();
  const {
    [FILTER_KEYS.LEAGUE]: league
  } = useFiltersState(specificScope, FILTER_KEYS.LEAGUE);
  const isNcaaLeague = league?.value.value === LEAGUES.NCAA || league?.value.value === LEAGUES.MLAX;
  const isDataOpsPage = scope === SCOPE.DATAOPS.ENTITIES;
  const {byTeam, entities:entitiesObject} = useSelector((state: RootState) => state.entities) as {byTeam: boolean, entities : Entities} ;
  return { byTeam, entitiesObject, isDataOpsPage, isNcaaLeague };
};

export const useEntitiesDispatch = () => {
  const dispatch = useDispatch();
  return { ...bindActionCreators({ ...action }, dispatch) };
};

